import { Component } from 'vue-property-decorator';
import AbstractDisplayField from '../abstract-display-field/abstract-display-field';
import { mixins } from 'vue-class-component';

@Component({
  name: 'bpc-display-pos-incidents-count',
  components: {},
})
export default class DisplayPosIncidentsCount extends mixins(AbstractDisplayField) {
  get variant(): string {
    return this.value > 0 ? 'warning' : 'success';
  }

  get valueLabel() {
    return this.value > 0
      ? this.value + ' ' + this.$t('global.pos_incidents_count.incidents')
      : this.$t('global.pos_incidents_count.no_incidents');
  }

  get showDataHoverIcon() {
    return this.fieldConfig.dataHoverIcon
      ? Object.keys(this.fieldConfig.dataHoverIcon).length > 0
      : false;
  }

  get hoverIcon() {
    const data = this.fieldConfig.dataHoverIcon;
    return data['icon'];
  }

  get hoverData() {
    const data = this.fieldConfig.dataHoverIcon;
    return this.item[data['data']];
  }
}
